/* @flow */

import * as React from 'react';

import './view-submission-data.css';

export type SubmittedField = {
    id: string,
    label: string,
    isRequired: boolean,
    value: ?(string | string[]),
};

type Props = {
    submittedFields: SubmittedField[],
};

export function ViewSubmissionData(props: Props) {
    const {submittedFields} = props;

    return (
        <dl styleName='view-submission-data'>
            {submittedFields.map((field) => (
                <div key={field.id}>
                    <dt>
                        {field.label}
                        {field.isRequired ? <span>*</span> : undefined}
                    </dt>
                    <dd>{getFieldValue(field.value)}</dd>
                </div>
            ))}
        </dl>
    );
}

function getFieldValue(value: ?(string | string[])) {
    if (!value) {
        return <span>No response</span>;
    } else if (Array.isArray(value)) {
        // Format will be: This, That, The other thing
        return value.join(', ');
    }

    // Otherwise, the value is already a string and we can just return it
    return value;
}
